<script>
export default {
  methods: {
    logoutImpersonation() {
      this.$store.dispatch('logoutImpersonation');
    },
  },
};
</script>

<template lang='pug'>
button.impersonation.text-white.px-_75.py-_5.rounded-lg(@click='logoutImpersonation') END SESSION
</template>

<style>
@import '~import/index';

.impersonation {
  background-color: $errorColor;
  position: fixed;
  transform: rotate(-90deg);
  top: 15rem;
  right: -45px;
  z-index: 2147483647;

  &:hover,
  &:focus {
    background-color: darken($errorColor, 10%);
  }
}
</style>